(function() {
  var Config;

  Config = require('resources/assets/coffee/Core/LaravelJs/Config/Repository').Repository;

  exports.Translator = (function() {
    function Translator(config) {
      this.config = config;
      this.lang = new Config({});
    }

    Translator.prototype.get = function(key, replacements, lang) {
      var curr, mapping, val;
      if (replacements == null) {
        replacements = [];
      }
      if (lang == null) {
        lang = null;
      }
      curr = lang != null ? lang : this.config.get('app.locale');
      mapping = this.config.get('app.language_mapping.' + curr);
      val = this.lang.get(curr + '.' + key);
      if (val == null) {
        if (mapping != null) {
          return this.get(key, replacements, mapping);
        }
        return key;
      }
      if (typeof val === 'string') {
        return val.replace(/: (\w+)/g, function(match, contents) {
          var ref;
          return (ref = replacements[contents]) != null ? ref : match;
        });
      }
      return val;
    };

    Translator.prototype.choice = function(key, number, replacements, lang) {
      var endnum, i, len, matches, p, parts, startnum, val, x;
      if (number == null) {
        number = 1;
      }
      if (replacements == null) {
        replacements = [];
      }
      if (lang == null) {
        lang = null;
      }
      val = this.get(key, replacements, lang);
      parts = val.split('|');
      if (parts.length === 1) {
        return parts[0];
      }
      matches = 0;
      for (i = 0, len = parts.length; i < len; i++) {
        p = parts[i];
        startnum = null;
        endnum = null;
        x = p.match(/\{(\d+)\}/);
        if ((x != null) && x.length > 1) {
          startnum = x[1];
          endnum = x[1];
        } else {
          x = p.match(/\[(\d+),(\d+)\]/);
          if ((x != null) && x.length > 2) {
            startnum = x[1];
            endnum = x[2];
          }
        }
        if ((startnum != null) && (endnum != null)) {
          matches++;
          if (startnum <= number && endnum >= number) {
            return p.replace(/\{\d+\}|\[\d+,\d+\]/, '').trim();
          }
        }
      }
      if (parts.length > 0 && matches < parts.length) {
        if (number === 1) {
          return parts[0].trim();
        }
        if (matches === parts.length - 2) {
          return parts[1].trim();
        }
      }
      return key;
    };

    return Translator;

  })();

}).call(this);
